import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';


Snappy.Component.GlobalCountdown = class GlobalCountDown extends Snappy.BaseComponent {
    static get tagName() {
        return 'global-countdown';
    }

    constructor(element) {
        super(element);
    }

    setVars() {
        this.countdownDate = this.$element.data("countdownDate");
    }

    init() {
        let element = ` <div class="days"><div class="numbers">00</div><span class="divider">:</span><span class="name">days</span></div>
                        <div class="hours"><div class="numbers">00</div><span class="divider">:</span><span class="name">hrs</span></div>
                        <div class="minutes"><div class="numbers">00</div><span class="divider">:</span><span class="name">mins</span></div>
                        <div class="seconds"><div class="numbers">00</div><span class="name">secs</span></div>`;

        this.$element.addClass('global-countDown');
        this.$element.find('.timer').html(element);

    }

    countDown() {
        let countdownDate = new Date(this.countdownDate).getTime();
        let now;
        let distance;

        let days;
        let hours;
        let minutes;
        let seconds;

        let daysText;
        let hoursText;
        let minutesText;
        let secondsText;

        //let daysArray = [];
        //let hoursArray = [];
        //let minutesArray = [];
        //let secondsArray = [];

        let x = setInterval(() => {

            now = new Date().getTime();
            distance = countdownDate - now;

            days = Math.floor(distance / (1000 * 60 * 60 * 24));
            hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            seconds = Math.floor((distance % (1000 * 60)) / 1000);

            daysText = `${days}`;
            hoursText = `${(hours < 10) ? '0' : ''}${hours}`;
            minutesText = `${(minutes < 10) ? '0' : ''}${minutes}`;
            secondsText = `${(seconds < 10) ? '0' : ''}${seconds}`;


            //let daysArrayNow = daysText.split('');
            //let hoursArrayNow = hoursText.split('');
            //let minutesArrayNow = minutesText.split('');
            //let secondsArrayNow = secondsText.split('');


            //daysArrayNow.map((number, i) => {
            //    if (daysArray[i] != number) {
            //        this.$element.find('.days .numbers').html(`${daysText}`)
            //    }
            //    daysArray[i] = number;
            //})
            //hoursArray.map((number) => {
            //    hoursText += `<span>${number}</span>`
            //})

            //minutesArray.map((number) => {
            //    minutesText += `<span>${number}</span>`
            //})

            //secondsArray.map((number) => {
            //    secondsText += `<span>${number}</span>`
            //})

            //let daysArray = ('0' + days).slice(-2).toString().split('');

            this.$element.find('.days .numbers').html(`<span>${daysText}</span>`)
            this.$element.find('.hours .numbers').html(`<span>${hoursText}</span>`)
            this.$element.find('.minutes .numbers').html(`<span>${minutesText}</span>`)

            this.$element.find('.seconds .numbers').html(`<span>${secondsText}</span>`)

            if (distance < 0) {
                clearInterval(x);
                this.$element.find('.days .numbers').html(`<span>00</span>`)
                this.$element.find('.hours .numbers').html(`<span>00</span>`)
                this.$element.find('.minutes .numbers').html(`<span>00</span>`)

                this.$element.find('.seconds .numbers').html(`<span>00</span>`)
            }
        }, 1000);
    }

    render() {
        this.setVars();
        this.init();
        this.countDown();
        // this.setEventListeners();
    }

}



// WEBPACK FOOTER //
// ./components/countdown/scripts/_countdown.js